import { Dispatch } from 'redux';
import checkOutSummaryAction from '../CheckOutSummary/actions';
import { ACTION_PREFIX, actionTypes } from './constants';
import { getActionOptions } from '../../lib/reduxActionsUtils';
import { createActions } from 'redux-actions';

export const { setCheckoutId, setIntentId } = createActions(actionTypes.SET_CHECKOUT_ID, actionTypes.SET_INTENT_ID, getActionOptions(ACTION_PREFIX));
const setCheckOutDataFromQueryString = (checkOutId: string) => {
  return async (dispatch: Dispatch<any>) => {
    dispatch(setCheckoutId(checkOutId));
    dispatch(checkOutSummaryAction.setCheckOut(checkOutId));
  };
};

const setIntentIdFromRoute = (intentId: string) => {
  return async (dispatch: Dispatch<any>) => {
    dispatch(setIntentId(intentId));
  };
};

export default {
  setCheckOutDataFromQueryString,
  setIntentIdFromRoute,
};
